export default {
  WEB_ACCEPT_ALL_TERMS: 'Accept',
  WEB_ACCOUNTS: 'Accounts',
  WEB_ADD: 'Add',
  WEB_ADDRESS: 'Address',
  WEB_ADD_ACCOUNT: 'Add account',
  WEB_ADD_ANOTHER_ACCOUNT: 'Add another',
  WEB_ADD_PAYMENT_METHOD_NOW: 'Add payment method now',
  WEB_ALL_APPOINTMENTS: 'All appointments',
  WEB_ALL_CLASSES: 'All classes',
  WEB_ALL_COURSES: 'All courses',
  WEB_ALL_FACILITIES: 'All facilities',
  WEB_ALL_TRAINERS: 'All trainers',
  WEB_ALREADY_BOOKED: 'Already Booked',
  WEB_ALREADY_HAVE_AN_ACCOUNT: 'Already have an account?',
  WEB_ALREADY_STARTED: 'Event passed',
  WEB_ANOTHER_CLIENT: 'Another client',
  WEB_AN_EMAIL_HAS_BEEN_SENT_TO_YOUR_ACCOUNT: 'An e-mail has been sent to your account',
  WEB_APPLIED_TO_JOINING_FEE: 'Applied to the joining fee',
  WEB_APPLY: 'Apply',
  WEB_APPLY_PROMO_CODE: 'Apply',
  WEB_APPOINTMENT_TYPE: 'Appointment Type',
  WEB_ATTENDANCE_POLICY: 'Attendance Policy',
  WEB_ATTENDANCE_POLICY_BOTH: 'If you can’t make it, please cancel at least {cancelWindow} hours before the class. Late cancellations are charged {late-cancel-fee}, and no-shows are charged {no-show-fee}.',
  WEB_ATTENDANCE_POLICY_BOTH_SAME_FEE: 'If you can’t make it, please cancel at least {cancelWindow} hours before the class. Late cancellations or no-shows are charged {no-show-fee}.',
  WEB_ATTENDANCE_POLICY_LATE_CANCEL: 'If you can’t make it, please cancel at least {cancelWindow} hours before the class. Late cancellations are charged {late-cancel-fee}.',
  WEB_ATTENDANCE_POLICY_NO_SHOW: 'If you can’t make it, please cancel before the class starts. No-shows are charged {no-show-fee}.',
  WEB_AUTORENEWING_EXPIRY_DATE: 'Autorenewing end date',
  WEB_AVAILABLE: 'Available',
  WEB_AVAILABLE_TODAY: 'Available today',
  WEB_BACK_TO_PAYG: 'Revert to Drop In Client ',
  WEB_BILLED_EVERY: 'Billed every',
  WEB_BIRTHDAY: 'Date of Birth',
  WEB_BOOK: 'Book',
  WEB_BOOKING_CANCELED: 'Booking cancelled',
  WEB_BOOKING_CANCEL_TEXT_1: 'You can cancel this booking now without a fee. If you don’t cancel and don’t attend, a {no_show} no-show fee applies. Free classes are exempt.',
  WEB_BOOKING_CANCEL_TEXT_2: 'Are you sure you want to cancel this booking? No fees will be charged if you cancel now.',
  WEB_BOOKING_CANCEL_TEXT_3: 'This class starts in less than {cancellation_window} hours. Cancelling now will result in a {late_cancel} late cancellation fee. If you don’t cancel and don’t attend, a {no_show} no-show fee applies instead. Free classes are exempt. Would you like to continue?',
  WEB_BOOKING_CANCEL_TEXT_4: 'This class starts in less than {cancellation_window} hours. Cancelling now will result in a {late_cancel} late cancellation fee. Free classes are exempt. Would you like to continue?',
  WEB_BOOKING_CANCEL_TEXT_6: 'You cannot cancel this booking. You have to cancel at least {cancellation_window} hours before the class starts. If you don’t attend, a {no_show} no-show fee applies. Free classes are exempt.',
  WEB_BOOKING_DISABLED: 'Booking disabled',
  WEB_BOOKING_INFO: 'Booking info: ',
  WEB_BOOK_ANOTHER_CLASS: 'Book another class',
  WEB_BOOK_A_CLASS: 'Book a class',
  WEB_BOOK_FRIEND_COUNT: 'Friend +{{count}}',
  WEB_BOOK_SPOT: 'Spot {{spot}}',
  WEB_BOOK_SPOT_ALREADY_TAKEN: 'This spot has already been assigned. Please choose a different spot.',
  WEB_BOOK_SPOT_BOOKING_FAILED: 'Spot booking failed.',
  WEB_BOOK_SPOT_CTA: 'Book this spot',
  WEB_BOOK_SPOT_LAYOUT_404_NETWORK_ERROR_MESSAGE: '404 network error',
  WEB_BOOK_SPOT_LAYOUT_ERROR_TITLE: 'Error',
  WEB_BOOK_SPOT_LAYOUT_UNAVAILABLE_MESSAGE: 'Booking is available without spot selection.',
  WEB_BOOK_SPOT_LAYOUT_UNAVAILABLE_TITLE: 'Layout unavailable',
  WEB_BOOK_SPOT_SELECT_PREFERRED: 'Select your preferred spot to complete your booking',
  WEB_BOOK_SPOT_SELECT_PREFERRED_WITH_FRIEND: 'Select a spot to complete your booking. Your friends will get an automatic spot prior the start of the class.',
  WEB_BOOK_SPOT_SKIP: 'Skip spot booking',
  WEB_BOOK_SPOT_SUCCESS: 'You succesfully booked:',
  WEB_BOOK_SPOT_TITLE: 'Book Spot',
  WEB_BOOK_SPOT_UNASSIGNED: 'Unassigned',
  WEB_BOOK_SPOT_UNAVAILABLE: 'This spot is unavailable',
  WEB_BOOK_YOUR_FIRST_CLASS: 'Book your first class!',
  WEB_BUY_MEMBERSHIP: 'Buy membership',
  WEB_BY_CONTINUING_TO_CREATE_AN_ACCOUNT_YOU_ARE_ACCEPTING_THE_STUDIO: 'By continuing to create an account you are accepting the studio\'s',
  WEB_CANCEL: 'Cancel',
  WEB_CANCEL_MEMBERSHIP: 'Cancel membership',
  WEB_CANCEL_MEMBERSHIP_FTC_FORM_BULLET_POINT_1: 'Your request will be sent to our team. You’ll receive an email confirmation once it’s processed.',
  WEB_CANCEL_MEMBERSHIP_FTC_FORM_BULLET_POINT_2: 'You’ll continue to have access until your final cancellation date.',
  WEB_CANCEL_MEMBERSHIP_FTC_FORM_BULLET_POINT_3: 'If your membership includes a minimum term or notice period, your cancellation will take effect based on the agreed',
  WEB_CANCEL_MEMBERSHIP_FTC_FORM_REASON_1: 'Price',
  WEB_CANCEL_MEMBERSHIP_FTC_FORM_REASON_2: 'Moved away',
  WEB_CANCEL_MEMBERSHIP_FTC_FORM_REASON_3: 'Medical',
  WEB_CANCEL_MEMBERSHIP_FTC_FORM_REASON_4: 'Lack of use',
  WEB_CANCEL_MEMBERSHIP_FTC_FORM_REASON_5: 'Customer service',
  WEB_CANCEL_MEMBERSHIP_FTC_FORM_REASON_6: 'Class schedule',
  WEB_CANCEL_MEMBERSHIP_FTC_FORM_REASON_7: 'Other',
  WEB_CANCEL_MEMBERSHIP_FTC_FORM_SUBTITLE: 'You are now cancelling {membershipName} {planName}.',
  WEB_CANCEL_MEMBERSHIP_FTC_FORM_SUBTITLE_2: 'Before we proceed with your cancellation for BLACK CARD MEMBERSHIP, can you tell us why do you want to cancel?',
  WEB_CANCEL_MEMBERSHIP_FTC_FORM_TITLE: 'We\'re sad to see you go.',
  WEB_CANCEL_MEMBERSHIP_FTC_REQUESTED_ALERT_TEXT: 'Your membership will remain active until the cancellation date. If you have any questions, please contact the studio at {studioEmail}.',
  WEB_CANCEL_MEMBERSHIP_FTC_REQUESTED_ALERT_TITLE: 'We\'ve received your cancellation request',
  WEB_CANCEL_MEMBERSHIP_FTC_SUCCESS_SUBTITLE: 'The studio will now process your cancellation according to cancellation policies. If you have any questions, please contact {studioEmail}.',
  WEB_CANCEL_MEMBERSHIP_FTC_SUCCESS_TITLE: 'We received your cancellation request.',
  WEB_CANCEL_REASON_PLACEHOLDER: 'Cancellation reason',
  WEB_CANCEL_YOUR_MEMBERSHIP: 'Cancel your membership',
  WEB_CARD: 'Card',
  WEB_CHANGE_PASSWORD: 'Change password',
  WEB_CHECK_BACK_SOON: 'Check back soon',
  WEB_CHECK_BACK_SOON_WHEN_OUR_SCHEDULE_IS_LIVE: 'Click Appointments Above to Complete Booking',
  WEB_CHECK_YOUR_EMAIL: 'Check your e-mail',
  WEB_CHILD_CAN_LOGIN: 'Child can login',
  WEB_CITY: 'City',
  WEB_CLASSES: 'Classes',
  WEB_CLASS_SIZE: 'Class size:',
  WEB_CLEAR: 'Clear',
  WEB_CLOSE: 'Close',
  WEB_COMPLETE_YOUR_PROFILE: 'Complete Your Profile',
  WEB_CONFIRMATION_PASSWORD_DOES_NOT_MATCH: 'Your Confirmation Password Does Not Match',
  WEB_CONFIRM_CANCEL_BOOKING: 'Cancel booking',
  WEB_CONFIRM_CANCEL_BOOKING_MESSAGE: 'Are you sure you want to cancel your booking?',
  WEB_CONFIRM_CANCEL_BOOKING_TITLE: 'Confirm booking cancellation',
  WEB_CONFIRM_CANT_CANCEL_BOOKING_MESSAGE_LATE_CANCEL: 'You cannot cancel this booking. You have to cancel at least {cancellation_window} hours before the class starts.',
  WEB_CONTACT_ADMIN_TO_GET_OLDER_BOOKINGS: 'Contact admin to get older bookings',
  WEB_CONTACT_GYM_TO_COMPLETE_SIGN_UP: 'Please contact the studio to complete registration.',
  WEB_CONTACT_STUDIO: 'Contact studio about your membership',
  WEB_CONTACT_STUDIO_ABOUT_MEMBERSHIP: 'Contact studio about membership',
  WEB_CONTINUE: 'Continue',
  WEB_COPY_MESSAGE: 'Copy',
  WEB_COUNTRY: 'Country',
  WEB_COURSES: 'Courses',
  WEB_CREATE_ACCOUNT: 'Create account',
  WEB_CREATE_ACCOUNT_SUBTITLE: 'First time with us? Please create an account to proceed.',
  WEB_CREATE_CHILD_ACCOUNT: 'Create a Child Account',
  WEB_CREATE_NEW_CHILD_ACCOUNT_MESSAGE: 'When you create a child account, you can buy memberships and book on their behalf.',
  WEB_CREATE_OR_ADD_AN_ACCOUNT: 'Add a child account',
  WEB_CREATE_YOUR_PASSWORD: 'Create your password.',
  WEB_CREDITS: 'Credits',
  WEB_CREDITS_DETAILS: 'Credits details',
  WEB_CURRENT_PASSWORD: 'Current password',
  WEB_CUSTOM_CHARGE: 'Custom charge',
  WEB_CUSTOM_WAIVER_TERMS: 'Terms and conditions',
  WEB_DATE_OF_BIRTH: 'Date of Birth',
  WEB_DAY: 'Day',
  WEB_DAYS: 'Days',
  WEB_DAY_ORDINAL_FORMAT: '{n}st|{n}nd|{n}rd|{n}th',
  WEB_DELETE: 'Delete',
  WEB_DEPENDANT_FIRST_NAME: 'Dependant first name',
  WEB_DEPENDANT_LAST_NAME: 'Dependant last name',
  WEB_DIRECT_DEBIT: 'Direct Debit',
  WEB_DISCOUNT_APPLIED: 'discount applied',
  WEB_DISCOUNT_APPLIES_TO_ALL_FUTURE_PAYMENTS: 'Applies to all future payments',
  WEB_DISCOUNT_APPLIES_TO_FIRST_NUM_CYCLES_PAYMENTS: 'Applies to first {{numCycles}} payments',
  WEB_DISCOUNT_APPLIES_TO_FIRST_PAYMENT_ONLY: 'Applies to first payment only',
  WEB_DOCUMENTS: 'Documents',
  WEB_DONE: 'Done',
  WEB_DONT_EXPIRE: 'Do not expire',
  WEB_EDIT_CARD: 'Edit card',
  WEB_EDIT_EC_PH: 'Name - phone(min:8 digits)',
  WEB_EDIT_MANDATE: 'Edit Direct Debit',
  WEB_EDIT_PHONE_PH: 'At least 8 digits',
  WEB_ELIGIBILITY_TO_BOOK: 'Booking Eligibility',
  WEB_EMAIL: 'Email',
  WEB_EMERGENCY_CONTACT: 'Emergency Contact and Phone',
  WEB_ENTER_PROMO_CODE_HERE: 'Enter promo code here',
  WEB_ERROR: 'Error',
  WEB_ERROR_CANCELLING: 'Cancel Failed',
  WEB_ERROR_LOADING_PRICE_AFTER_TAX: 'Error loading the price after tax applied',
  WEB_EVENT_IS_FULL: 'Event is full',
  WEB_EVENT_PASSED: 'Event passed',
  WEB_EVERY: 'Every',
  WEB_EXPIRY_DATE: 'Expiry date',
  WEB_FACEBOOK: 'Facebook',
  WEB_FACILITIES: 'Facilities',
  WEB_FAILED: 'Failed',
  WEB_FAILED_TO_FETCH_TAX_BREAKDOWN: 'Error loading prices',
  WEB_FAMILY_ACCOUNTS: 'My Family',
  WEB_FILL_IN_ACCOUNT_DETAILS: 'Fill in Account Details',
  WEB_FILL_IN_YOUR_DETAILS: 'Fill in your details',
  WEB_FILTERS: 'Filters',
  WEB_FIRST_NAME: 'First name',
  WEB_FORGOT_PASSWORD: 'Forgot password',
  WEB_FORGOT_PASSWORD_MESSAGE: 'You will receive an e-mail with instructions to reset your password.',
  WEB_FORGOT_PASSWORD_QUESTION: 'Forgot password?',
  WEB_FREE: 'Free',
  WEB_FREE_EVENT: 'Free',
  WEB_FREE_MEMBERSHIP: 'Free',
  WEB_FTC_ACCEPT_RENEWAL: 'I accept',
  WEB_FTC_AUTO_RENEW: 'Contract is valid for {timeDurationAndPeriod} and will auto-renew after that time.',
  WEB_FTC_AUTO_RENEW_DIALOGUE: 'I acknowledge and agree that my subscription will automatically renew for {timeDurationAndPeriod} and will auto-renew after that time unless I cancel in accordance with the membership agreement. You can cancel anytime in the club or through the website by navigating to your Profile / My membership / Cancel Membership.',
  WEB_FTC_CANCEL_GROUP_MEMBERSHIP: 'This membership is part of a group plan. Only the group owner can cancel it. To leave the group, please contact us at {branchEmail}.',
  WEB_FTC_CANCEL_GROUP_MEMBERSHIP_BUTTON: 'Ok',
  WEB_FTC_CANCEL_GROUP_MEMBERSHIP_TITLE: 'Group plan membership.',
  WEB_FTC_CANCEL_MEMBERSHIP_HOME_BRANCH: 'To successfully request the cancellation of your membership you need to do it from your home studio.',
  WEB_FTC_CANCEL_MEMBERSHIP_HOME_BRANCH_BUTTON: 'Ok',
  WEB_FTC_CANCEL_MEMBERSHIP_HOME_BRANCH_TITLE: 'Access home studio.',
  WEB_FTC_CONSENT_TO_AUTORENEWAL_TERMS: 'I acknowledge and agree that my subscription will automatically renew until I cancel in accordance with the membership agreement. You can cancel anytime in the club or from your profile in the web portal.',
  WEB_FTC_NON_AUTO_RENEW: 'Contract is valid for {timeDurationAndPeriod}.',
  WEB_FTC_NON_AUTO_RENEW_DIALOGUE: 'I acknowledge and agree that my subscription will automatically renew for {timeDurationAndPeriod} or until I cancel in accordance with the membership agreement. You can cancel anytime in the club or through the website by navigating to your Profile / My membership / Cancel Membership.',
  WEB_FTC_NO_END_DATE: 'Subscription will be active until you cancel.',
  WEB_FTC_NO_END_DATE_DIALOGUE: 'I acknowledge and agree that my subscription will automatically renew until I cancel in accordance with the membership agreement. You can cancel anytime in the club or through the website by navigating to your Profile / My membership / Cancel Membership.',
  WEB_FTC_TITLE_ALERT_RENEWAL: 'Auto-renewal conditions',
  WEB_FULL: 'Full',
  WEB_GDPR_CONSENT_SMS_LINK_TEXT: 'See SMS t&c\'s and privacy policy',
  WEB_GDPR_CONSENT_TO_MARKETING_HEADING_WEB_PORTAL: 'Would you like to be kept informed about upcoming events and promotions?',
  WEB_GDPR_CONSENT_TO_MARKETING_SMS: 'Yes, I consent to receiving SMS texts about upcoming events and/or promotions that may be of interest to me from {branchName} to the phone number that I provided. Message frequency varies, data rates may apply. Reply STOP to opt-out.',
  WEB_GDPR_DEADLINE_MESSAGE: 'Every now and again, we send an email or push notification about upcoming events, special promotions or pieces of news we think you may be interested in. Tick here to keep in the know!',
  WEB_GDPR_DEADLINE_TITLE: 'Contact Preferences',
  WEB_GENERAL_LABEL: 'General label',
  WEB_GENERAL_MESSAGE: 'General message',
  WEB_GENERAL_TITLE: 'General Title',
  WEB_GENERIC_REGISTER_ERROR: 'There was an error with the registration.',
  WEB_GO_PAYG: 'Yes',
  WEB_GO_TO_MY_PROFILE: 'Return to my Profile',
  WEB_GUARDIAN_EMAIL: 'Guardian\'s email address',
  WEB_GUARDIAN_LAST_NAME: 'Guardian\'s last name',
  WEB_GUARDIAN_MOBILE_PHONE: 'Guardian\'s phone number',
  WEB_GUARDIAN_NAME: 'Guardian\'s First Name',
  WEB_GUARDIAN_WAIVER: 'Guardian Waiver',
  WEB_GUEST_SESSION_EXPIRED_REFRESH_PAGE: 'Guest session has expired, please reload and refresh.',
  WEB_GUEST_SESSION_EXPIRED_TITLE: 'Guest session expired.',
  WEB_HAPPY_BIRTHDAY: 'Enjoy your special day!',
  WEB_HEADER_APPOINTMENTS: 'Appointments',
  WEB_HEADER_CLASSES: 'Classes',
  WEB_HEADER_COURSES: 'Courses',
  WEB_HEADER_FACILITIES: 'Facilities',
  WEB_HEADER_MEMBERSHIPS: 'Memberships',
  WEB_HEADER_SECTIONS: 'Sections',
  WEB_HI: 'Hi',
  WEB_HIDE: 'Hide',
  WEB_HOUR: 'hour',
  WEB_HOURS: 'hours',
  WEB_IMMEDIATE_PAUSE_MEMBERSHIP_SUCCESS_MESSAGE: 'Your membership was successfully paused.',
  WEB_INCORRECT_LOGIN_DETAILS: 'Incorrect login details',
  WEB_INSTAGRAM: 'Instagram',
  WEB_INVALID_START_DATE: 'Invalid start date',
  WEB_INVALID_START_DATE_MESSAGE: 'Start date must be between {min_date} and {max_date}',
  WEB_INVITE_LINK: 'Invitation link',
  WEB_I_ACCEPT: 'I accept',
  WEB_I_AGREE_AUTORENEWAL_CS: 'I agree with auto-renewal conditions.',
  WEB_I_AGREE_TO: 'I agree to',
  WEB_I_AGREE_TO_THE: 'I agree to the',
  WEB_JOINED: 'Joined',
  WEB_JOINING_FEE: 'Joining fee',
  WEB_JOIN_BOOKING_LIST: 'Join waiting list',
  WEB_JOIN_WAITING_LIST: 'Join waiting list',
  WEB_LAST_NAME: 'Last name',
  WEB_LEAVE_WAITLIST: 'Leave waitlist',
  WEB_LINK_COPIED_TO_CLIPBOARD: 'Link copied to clipboard',
  WEB_LOGIN: 'Log in',
  WEB_LOGIN_INSTEAD: 'Log in instead',
  WEB_LOGIN_OR_SIGNUP: 'Login or Create an account',
  WEB_LOGIN_REGISTER_DOB_FIELD_INVALID_MESSAGE: 'Please fill in your birthday correctly.',
  WEB_LOGIN_REGISTER_DOB_FIELD_INVALID_TITLE: 'Invalid DOB',
  WEB_LOGIN_SUBTITLE: 'If you already have an account with us, you can use it to login here.',
  WEB_LOGIN_WEBPORTAL: 'Login / Register',
  WEB_LOGOUT: 'Log out',
  WEB_MAINTENANCE_FEE_MESSAGE: '*A {fee_name} of {amount} will be charged {delay_charge_days} days after your membership start date, and every {interval_count} {interval_unit} after the first charge.',
  WEB_MANAGE_MEMBERSHIP: 'Manage membership',
  WEB_MANAGE_YOUR_MEMBERSHIP: 'Manage your membership',
  WEB_MEMBERSHIP: 'Membership',
  WEB_MEMBERSHIP_DETAILS: 'Membership details',
  WEB_MEMBERSHIP_DETAILS_CHECK_ON_PROFILE: 'Please refer to your profile to view membership details.',
  WEB_MEMBERSHIP_NOTIFICATION: 'Membership Notification',
  WEB_MEMBERSHIP_PLAN: 'Plan',
  WEB_MEMBERSHIP_PURCHASE_TERMS: ' Membership Terms & Conditions.',
  WEB_MEMBERSHIP_TERMS_AND_CONDITIONS: 'Membership T&C\'s',
  WEB_MEMBER_TAX_ID_NUMBER: 'Tax Id Number',
  WEB_MINUTE: 'minute',
  WEB_MINUTES: 'Minutes',
  WEB_MOBILE_NUMBER: 'Mobile number',
  WEB_MONTH: 'Month',
  WEB_MONTHS: 'Months',
  WEB_MONTH_APRIL: 'April',
  WEB_MONTH_AUGUST: 'August',
  WEB_MONTH_DECEMBER: 'December',
  WEB_MONTH_FEBRUARY: 'February',
  WEB_MONTH_JANUARY: 'January',
  WEB_MONTH_JULY: 'July',
  WEB_MONTH_JUNE: 'June',
  WEB_MONTH_MARCH: 'March',
  WEB_MONTH_MAY: 'May',
  WEB_MONTH_NOVEMBER: 'November',
  WEB_MONTH_OCTOBER: 'October',
  WEB_MONTH_SEPTEMBER: 'September',
  WEB_MONTH_SHORT_APRIL: 'Apr',
  WEB_MONTH_SHORT_AUGUST: 'Aug',
  WEB_MONTH_SHORT_DECEMBER: 'Dec',
  WEB_MONTH_SHORT_FEBRUARY: 'Feb',
  WEB_MONTH_SHORT_JANUARY: 'Jan',
  WEB_MONTH_SHORT_JULY: 'Jul',
  WEB_MONTH_SHORT_JUNE: 'Jun',
  WEB_MONTH_SHORT_MARCH: 'Mar',
  WEB_MONTH_SHORT_MAY: 'May',
  WEB_MONTH_SHORT_NOVEMBER: 'Nov',
  WEB_MONTH_SHORT_OCTOBER: 'Oct',
  WEB_MONTH_SHORT_SEPTEMBER: 'Sep',
  WEB_MY_BOOKINGS: 'Bookings',
  WEB_MY_MEMBERSHIP: 'My membership',
  WEB_MY_TRANSACTIONS: 'My transactions',
  WEB_NEW_PASSWORD: 'New password',
  WEB_NEXT_PAYMENT_DATE: 'Next Payment Due',
  WEB_NOT_ELIGIBLE: 'Not eligible',
  WEB_NOT_ELIGIBLE_TO_BOOK: 'Not eligible',
  WEB_NOT_SIGNED: 'Not signed',
  WEB_NO_ACCOUNTS_ASSOCIATED_MESSAGE: 'You can book and buy on behalf of child accounts in your Family.',
  WEB_NO_APPOINTMENTS: 'No appointments',
  WEB_NO_APPOINTMENTS_CURRENTLY_LISTED: 'No Appointments Currently Listed',
  WEB_NO_CLASSES_AVAILABLE: 'No classes available',
  WEB_NO_COURSES_ARE_CURRENTLY_LISTED: 'No courses currently listed',
  WEB_NO_FACILITIES_CURRENTLY_LISTED: 'No Facilities are Currently Listed',
  WEB_NO_MEMBERSHIPS_ARE_CURRENTLY_LISTED: 'No memberships currently listed',
  WEB_NSF_FEE: 'Non-Sufficient Funds Fee',
  WEB_NUMBER_OF_ATTENDANTS: 'Bring a friend?',
  WEB_OK: 'Ok',
  WEB_ONE_SPOT_AVAILABLE: '1 spot available',
  WEB_ONE_TIME_PURCHASE: 'One time purchase',
  WEB_ON_WAITING_LIST: 'On waiting list',
  WEB_OTHER_ADVERTISING: 'Other advertising',
  WEB_OUTSTANDING_DOCUMENTS_WARNING: 'Unsigned E-Agreements. Sign before booking or you may be denied access.',
  WEB_OUTSTANDING_PROFILE_DETAILS: 'There\'s missing information on your profile. Please edit and complete.',
  WEB_OUTSTANDING_PROFILE_INFO_WARNING: 'There\'s missing information on your profile. Please complete your profile before booking. Click here to complete your profile.',
  WEB_PARENTAL_WAIVER: 'Parental Waiver',
  WEB_PARENT_ACCOUNT_MESSAGE: 'You are using one of your child accounts',
  WEB_PASSWORD: 'Password',
  WEB_PASSWORDS_MATCH: 'CONFIRM PASSWORD',
  WEB_PASSWORD_SUCCESSFULLY_CHANGED: 'Password successfully changed',
  WEB_PASSWORD_SUCCESSFULLY_SET: 'Password successfully set',
  WEB_PAST_BOOKINGS: 'Past bookings',
  WEB_PAUSE_ENDS: 'Pause ends',
  WEB_PAUSE_FOR: 'Pause for',
  WEB_PAUSE_INSTEAD: 'Pause instead',
  WEB_PAUSE_MEMBERSHIP: 'Pause membership',
  WEB_PAUSE_MEMBERSHIP_DURATION_TITLE: 'Please, select a duration for your pause:',
  WEB_PAUSE_MEMBERSHIP_START_DATE_TITLE: 'Do you want to pause now or select a date in the future?',
  WEB_PAUSE_MEMBERSHIP_SUCCESS_DESCRIPTION: 'Class bookings in this period will be cancelled when the pause takes effect (applies only to bookings made using this membership).',
  WEB_PAUSE_NOW: 'Pause now',
  WEB_PAUSE_ON_A_SPECIFIC_DATE: 'Pause on a specific date',
  WEB_PAUSE_STARTS: 'Pause starts',
  WEB_PAYG_PAYMENT_TERMS: 'Terms and Conditions',
  WEB_PAYG_TERMS_AND_CONDITIONS: 'Pay-As-You-Go T&C\'s',
  WEB_PAYMENT_METHOD_ADD_UNBLOCK: 'Adding your payment method details now will enable you to book beyond your membership renewal date due on.',
  WEB_PAYMENT_METHOD_CONFIRMATION_DELETE_CARD_MESSAGE: 'Are you sure you want to delete this card?',
  WEB_PAYMENT_METHOD_CONFIRMATION_DELETE_MANDATE_MESSAGE: 'Are you sure you want to delete this direct debit?',
  WEB_PAYMENT_PROVIDER_NOT_AVAILABLE: 'Payment provider not available',
  WEB_PAYMENT_TO_BE_VERIFIED: 'This payment must be verified',
  WEB_PENDING: 'Pending',
  WEB_PHONE: 'Phone',
  WEB_PHONE_NUMBER: 'Phone number',
  WEB_PLEASE_ACCEPT_AUTORENEWAL_TERMS_AND_CONDITIONS: 'Please accept the autorenewal terms and conditions.',
  WEB_PLEASE_ACCEPT_GUARDIAN_WAIVER: 'Please accept the guardian waiver to complete creating a child account',
  WEB_PLEASE_ACCEPT_TERMS_AND_CONDITIONS: 'Please accept the terms and conditions.',
  WEB_PLEASE_SCROLL_TCS_AND_ACCEPT: 'Scroll to read and accept the Terms and Conditions.',
  WEB_PLEASE_TRY_AGAIN: 'Please try again',
  WEB_PLUS_UPFRONT_FEE: 'joining fee',
  WEB_PORTAL_PASSWORD_CRITERIA_ITEM_1: 'one uppercase letter (A-Z)',
  WEB_PORTAL_PASSWORD_CRITERIA_ITEM_2: 'one lowercase letter (a-z)',
  WEB_PORTAL_PASSWORD_CRITERIA_ITEM_3: 'one number (0-9)',
  WEB_PORTAL_PASSWORD_CRITERIA_ITEM_4: 'one symbol (!@#$%^&*-+=?)',
  WEB_PORTAL_PASSWORD_CRITERIA_TITLE: 'Password must be at least 8 characters in length with:',
  WEB_POSTAL_CODE: 'Postal code',
  WEB_POWERED_BY: 'Powered by',
  WEB_PREVIEW_STUDIO_WAIVER: 'Preview your studios T&cs',
  WEB_PRICE: 'Price',
  WEB_PRICE_BREAKDOWN_FIRST_PERIOD_FREE: 'First period is free',
  WEB_PRICE_BREAKDOWN_PRORATED_NET_PRICE: 'Prorated price',
  WEB_PRIVACY_POLICY: 'Privacy Policy',
  WEB_PRIVACY_POLICY_ACCEPT_PRE_TEXT: 'By creating an account, you agree to our',
  WEB_PROFILE: 'Profile',
  WEB_PROMO_CODE_APPLIED_SUCCESSFULLY: 'Promo code successfully applied.',
  WEB_PROMO_CODE_APPLIED_SUCCESSFULLY_FUTURE: 'Promo code successfully applied to future charges.',
  WEB_PROMO_CODE_APPLIED_SUCCESSFULLY_JOINING_FEE: 'Promo code successfully applied to joining fee',
  WEB_PURCHASE: 'Purchase',
  WEB_REFERRAL: 'Referral',
  WEB_REFRESH_PAGE: 'Please, reload and refresh.',
  WEB_REGISTER: 'Register',
  WEB_REMIND_ME_LATER: 'Remind me later',
  WEB_REPEAT_NEW_PASSWORD: 'Repeat new password',
  WEB_REPEAT_PASSWORD: 'Repeat password',
  WEB_REPLACE: 'Replace',
  WEB_REVERT_TO_PAYG: 'Revert to Drop In Client',
  WEB_SAVE_CHANGES: 'Save Changes',
  WEB_SCA_CHECKBOX_VERIFIED: 'I have verified the payment',
  WEB_SCA_CONTENT_FAILED: 'We couldn\'t perform the payment authorisation.',
  WEB_SCA_DONE: 'Done',
  WEB_SCA_EXPLAINED: 'Check your email for the link to verify the payment with your bank or payment provider. When this is complete, click done below',
  WEB_SCA_HEADER: 'This payment must be verified',
  WEB_SCA_HEADER_FAILED: 'Authorisation failed',
  WEB_SCA_HEADER_PENDING: 'Payment hasn\'t been verified',
  WEB_SCA_STEPS_CHECK_EMAIL: 'Check your email for the link to verify the payment',
  WEB_SCA_STEPS_CLICK_DONE: 'Return here and click “Done” below to continue',
  WEB_SCHEDULE: 'Schedule',
  WEB_SCHEDULE_PAUSE_MEMBERSHIP_SUCCESS_MESSAGE: 'Your pause was successfully scheduled.',
  WEB_SCROLL_TO_ACCEPT: 'Scroll to accept',
  WEB_SELECT_DATE: 'Select a date',
  WEB_SELECT_YOUR_PAYMENT_METHOD: 'Select Payment method',
  WEB_SHARE: 'Share',
  WEB_SHOW: 'Show',
  WEB_SHOW_MORE: 'Show more',
  WEB_SIGN_DOCUMENT: 'Sign',
  WEB_SIGN_UP_BOOK: 'Sign up to book',
  WEB_SIGN_UP_FOR_MORE_INFORMATION: 'Register Your Interest',
  WEB_SIGN_UP_PURCHASE: 'Sign up to purchase',
  WEB_SLOTS: 'Slots',
  WEB_SMS_TERMS_AND_CONDITIONS: 'SMS Terms of Service and Privacy Policy',
  WEB_SOMETHING_WENT_WRONG: 'Something went wrong',
  WEB_SORRY_YOU_ARE_NOT_ELIGIBLE_TO_BOOK_THIS_EVENT: 'Sorry, You Are Not Eligible to Book This Event!',
  WEB_SPOTS_AVAILABLE_COUNT: '{count} spots available',
  WEB_STARTING_DATE: 'Start date',
  WEB_STARTS_AFTER_CURRENT_MEMBERSHIP: 'After current membership',
  WEB_START_AT_FIRST_BOOKING: 'Starts on first booking -',
  WEB_START_DATE: 'Start date',
  WEB_STATE: 'State',
  WEB_STAY_LOGGED_IN: 'Keep me logged in',
  WEB_STREET: 'Street',
  WEB_STRIPE_CHARGE: 'Credit/Debit Card',
  WEB_STUDIO_WAIVER: 'Studio Waiver',
  WEB_SUBMIT: 'Submit',
  WEB_SUBSCRIPTION: 'Subscription',
  WEB_SUBSCRIPTION_SUBTOTAL: 'Subscription subtotal',
  WEB_SUBTOTAL: 'subtotal',
  WEB_SURCHARGE_FEE_MESSAGE: 'A surcharge of 1 AUD will be applied to the total value after purchasing with a card; only if the total isn\'t zero.',
  WEB_SWITCH_BACK_TO_YOUR_ACCOUNT: 'Switch back',
  WEB_SWITCH_TO_PARENT: 'Switch to Parent',
  WEB_TERMS_AND_CONDITIONS: 'TERMS AND CONDITIONS',
  WEB_THANK_YOU: 'Thank you',
  WEB_THANK_YOU_FOR_REGISTERING_INTEREST_AT: 'Thank you for registering interest at',
  WEB_THERE_ARE_NO_BOOKINGS_YET: 'There are no bookings yet',
  WEB_THERE_ARE_NO_TRANSACTIONS_YET: 'There are no transactions yet',
  WEB_THERE_WAS_AN_ERROR_ADDING_YOUR_PAYMENT_DETAILS: 'There was an error adding your payment details',
  WEB_THERE_WAS_AN_ERROR_CHANGING_PASSWORD: 'There was an error saving your password. Please try again. If the issue continues, contact us at the helpdesk',
  WEB_THERE_WAS_AN_ERROR_COLLECTING_YOUR_DETAILS: 'There was an error collecting your details.',
  WEB_THERE_WAS_AN_ERROR_REGISTERING: 'There was an error with the registration. Please try again, if the issue continues contact the helpdesk',
  WEB_THERE_WAS_AN_ERROR_REGISTERING_CHILD_ACCOUNT: 'There was an error with the registration. Please try again, if the issue continues contact the helpdesk.',
  WEB_THERE_WAS_AN_ERROR_RESETTING_YOUR_PASSWORD: 'There was an error saving your password. Make sure your password is at least 8 characters long with at leaset 1 number and 1 letter.',
  WEB_THERE_WAS_AN_ERROR_REVERTING_TO_PAYG: 'There was an error reverting the membership, please try again later.',
  WEB_THE_USER_ALREADY_EXISTS_ERROR: 'This email is already registered. Please try again with a different email or log in if you already have an account.',
  WEB_THIS_FACILITY_HAS_NO_AVAILABLE_TIME_SLOTS: 'This facility has no available time slots',
  WEB_THIS_TRAINER_HAS_NO_AVAILABLE_TIME_SLOTS: 'This trainer has no available time slots',
  WEB_TOKEN_EXPIRED: 'Your session has expired.',
  WEB_TOKEN_HAS_EXPIRED_PLEASE_LOGIN_AGAIN: 'Please login again to continue booking.',
  WEB_TOTAL_TO_PAY_TODAY: 'Total to pay today',
  WEB_TRAINERS: 'Trainers',
  WEB_TRANSACTIONS: 'Transactions',
  WEB_TRIAL_PURCHASE: 'Purchase',
  WEB_TRY_AGAIN: 'Try again',
  WEB_UNABLE_TO_CREATE_CART_FOR_PAYMENT: ' There was an error creating the cart. Please contact your studio for further assistance.',
  WEB_UNDER_AGE_NOT_ALLOW_TO_REGISTER: 'You are younger than the minimum age to create an account',
  WEB_UNDER_AGE_PLEASE_CONTACT_YOUR_GUARD: 'You are younger than the minimum age to create an account.',
  WEB_UNDER_AGE_REGISTER_MESSAGE_TO_GUARD: 'Send instructions to your guardian, so they can create an account for you',
  WEB_UNDER_AGE_TITLE: 'Minimum Age',
  WEB_UNDO: 'Undo',
  WEB_UNLIMITED_MEMBERSHIP: 'Unlimited membership',
  WEB_UPCOMING: 'Upcoming',
  WEB_UPDATE_PROFILE_RESTRICTED_BUTTON: 'Close',
  WEB_UPDATE_PROFILE_RESTRICTED_MESSAGE: 'Due to studio policy, you can\'t edit your personal information via Website. Contact the studio to update your information.',
  WEB_UPDATE_PROFILE_RESTRICTED_TITLE: 'Editing personal information restriction',
  WEB_UPDATE_USER_IMAGE_FIRST_TIME_BUTTON: 'Upload new image',
  WEB_UPDATE_USER_IMAGE_FIRST_TIME_MESSAGE: 'You can only upload your profile picture once. It will be visible to staff for identification. If you need to change it again, contact your studio.',
  WEB_UPFRONT_FEE: 'Upfront fee',
  WEB_USER_EMAIL: 'User email',
  WEB_USER_FIRSTNAME: 'User first name',
  WEB_USER_HAS_LOCKED_MEMBERSHIP_WARNING: 'Your current membership is locked. Please resolve by contacting the studio to purchase a new one.',
  WEB_USER_LASTNAME: 'User last name',
  WEB_USE_ACCOUNT: 'Use',
  WEB_USE_PARENT_CARD: 'Use Guardian\'s Card',
  WEB_USING_CHILD_ACCOUNT: 'Using Child Account -',
  WEB_VALID_FOR: 'Valid for',
  WEB_VIEW_MEMBERSHIPS_AND_CREDITS: 'View memberships & credits',
  WEB_VIEW_SCHEDULE: 'View Schedule',
  WEB_WAITING_LIST: 'Waiting list',
  WEB_WAITING_LIST_WARNING: 'You wont be charged unless you\'re moved from the waiting list to the booking list of the class.',
  WEB_WAIVER: 'Waiver',
  WEB_WEEK: 'Week',
  WEB_WEEKDAY_FRI: 'Fri',
  WEB_WEEKDAY_FRIDAY: 'Friday',
  WEB_WEEKDAY_MIN_FRIDAY: 'Fr',
  WEB_WEEKDAY_MIN_MONDAY: 'Mo',
  WEB_WEEKDAY_MIN_SATURDAY: 'Sa',
  WEB_WEEKDAY_MIN_SUNDAY: 'Su',
  WEB_WEEKDAY_MIN_THURSDAY: 'Th',
  WEB_WEEKDAY_MIN_TUESDAY: 'Tu',
  WEB_WEEKDAY_MIN_WEDNESDAY: 'We',
  WEB_WEEKDAY_MON: 'Mon',
  WEB_WEEKDAY_MONDAY: 'Monday',
  WEB_WEEKDAY_SAT: 'Sat',
  WEB_WEEKDAY_SATURDAY: 'Saturday',
  WEB_WEEKDAY_SHORT_FRIDAY: 'Fri',
  WEB_WEEKDAY_SHORT_MONDAY: 'Mon',
  WEB_WEEKDAY_SHORT_SATURDAY: 'Sat',
  WEB_WEEKDAY_SHORT_SUNDAY: 'Sun',
  WEB_WEEKDAY_SHORT_THURSDAY: 'Thu',
  WEB_WEEKDAY_SHORT_TUESDAY: 'Tue',
  WEB_WEEKDAY_SHORT_WEDNESDAY: 'Wed',
  WEB_WEEKDAY_SUN: 'Sun',
  WEB_WEEKDAY_SUNDAY: 'Sunday',
  WEB_WEEKDAY_THU: 'Thu',
  WEB_WEEKDAY_THURSDAY: 'Thursday',
  WEB_WEEKDAY_TUE: 'Tue',
  WEB_WEEKDAY_TUESDAY: 'Tuesday',
  WEB_WEEKDAY_WED: 'Wed',
  WEB_WEEKDAY_WEDNESDAY: 'Wednesday',
  WEB_WEEKS: 'Weeks',
  WEB_WELCOME_BACK_MESSAGE: 'Welcome Back',
  WEB_WE_WILL_BE_IN_TOUCH_SOON_WITH_MORE_INFORMATION: 'We will be in touch soon with more information',
  WEB_WE_WISH_YOU_A_HAPPY_BIRTHDAY: 'Enjoy your special day!',
  WEB_WORD_OF_MOUTH: 'Word of mouth',
  WEB_YOUR_CARD_WILL_BE_CHARGED: 'Reserve your spot for',
  WEB_YOUR_MEMBERSHIP_ALREADY_EXPIRED: 'Your Membership has expired, would you like to continue as a Drop-in Client?',
  WEB_YOUR_SIGNATURE: 'Your signature',
  WEB_YOU_ARE_NOT_ALLOWED_TO_BUY_THIS_MEMBERSHIP: 'You are not allowed to buy this membership',
  WEB_YOU_ARE_READY_TO_START_YOUR_TRIAL: 'You are ready to start your trial!',
  WEB_YOU_FAILED_BOOKING: 'There was a problem with the booking:',
  WEB_YOU_FAILED_BUYING: 'There was a problem with the transaction:',
  WEB_YOU_SUCCESSFULLY_BOOKED: 'You successfully booked:',
  WEB_YOU_SUCCESSFULLY_BOUGHT: 'You successfully bought:',
  WEB_YOU_SUCCESSFULLY_GOT_REGISTERED: 'Registration successful!',
  WEB_YOU_SUCCESSFULLY_JOINED_WAITING_LIST: 'You successfully joined the waiting list!',
  WEB_ZIP_CODE: 'Zip Code',
};
